import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/usage/mcp/usage.mcpCustomer.query.gql"
import type {
  UsageMcpCustomerQuery,
  UsageMcpCustomerQueryVariables,
} from "@/v2-backoffice-client/usage/mcp/__types__/usage.mcpCustomer.query"

type Options = QueryHookOptions<
  UsageMcpCustomerQuery,
  UsageMcpCustomerQueryVariables
>

export function useUsageMcpCustomerQuery(options?: Options) {
  return useQuery<UsageMcpCustomerQuery, UsageMcpCustomerQueryVariables>(
    query,
    options,
  )
}
